<template>
    <v-dialog v-model="show" max-width="450" persistent no-click-animation>
        <div class="ConfirmDeleteCustomerFromTo">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('deleteCustomer') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!-- Dialog body -->
            <div class="dialog-content">
                <div class="mb-8">{{ $f.tc('confirmDelete', {item: "customers"}) }}</div>
                <v-radio-group v-model="currentDeleteOption" hide-details>
                    <v-radio
                        v-for="option in configDeleteOptions"
                        :key="option.value"
                        :label="option.text"
                        :value="option.value"
                        color="#0052CC"
                    ></v-radio>
                </v-radio-group>
                <div class="mt-12" style="font-size: 13px; font-style: italic; color: red">
                    <strong>*{{ $f.tc('notice') }}</strong>:
                    {{ $t('deleteCustomerNotice', { nameTab: $f.tc('output') }) }}
                </div>
            </div>
            <!--Dialog footer-->
            <div class="dialog-footer">
                <div class="btn-outline btn-delete mr-8" @click="deleteCustomers">{{
                        $f.tc('delete')
                    }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>

const DELETE_OPTIONS = {
    DELETE_FROM_TO: 'DELETE_FROM_TO',
    DELETE_ALL: 'DELETE_ALL'
}

import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import CampaignService from "@/services/campaign.service";

export default {
    name: "ConfirmDeleteCustomerFromTo",
    mixins: [DialogPromiseMixin, FormMixin],
    props: {
        filter: Object,
    },
    data() {
        return {
            DELETE_OPTIONS,
            campaign: {},
            currentDeleteOption: DELETE_OPTIONS.DELETE_FROM_TO,
            timestamp: {},
        }
    },
    computed: {
        configDeleteOptions() {
            return [
                {
                    text: this.$t('fromTo', {from: this.filter.from_date, to: this.filter.to_date}),
                    value: DELETE_OPTIONS.DELETE_FROM_TO
                },
                {
                    text: this.$t('clearAllCustomers'),
                    value: DELETE_OPTIONS.DELETE_ALL
                }
            ]
        }
    },
    methods: {
        open(campaign, timestamp) {
            this.show = true
            this.timestamp = timestamp
            this.campaign = campaign
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        close() {
            this.show = false
            this.promise.resolve()
            this.$emit('close')
        },
        deleteFromToCustomers() {
            this.$appService.showLoading()
            CampaignService.deleteFromToCustomer(
                this.campaign.id,
                this.timestamp
            ).then(
                () => {
                    this.close()
                }
            ).finally(this.$appService.hideLoading)
        },
        deleteAllCustomer() {
            this.$appService.showLoading()
            CampaignService.deleteAllCustomer(this.campaign.id).then(
                () => {
                    this.close()
                }
            ).finally(this.$appService.hideLoading)
        },
        deleteCustomers() {
            if (!this.currentDeleteOption) {
                return
            }
            switch (this.currentDeleteOption) {
                case DELETE_OPTIONS.DELETE_FROM_TO:
                    this.deleteFromToCustomers()
                    break
                case DELETE_OPTIONS.DELETE_ALL:
                    this.deleteAllCustomer()
                    break
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ConfirmDeleteCustomerFromTo {
    position: relative;
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-left: 8px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi";
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }

    .text-upload {
        font-size: 14px;
        padding: 12px;
    }

    .btn-delete {
        background: #dc3545 !important;
        color: #FFFFFF !important;
        border: 1px solid #dc3545 !important;

        &:hover {
            background: #dc3545bf !important;
            border: 1px solid #dc354500 !important;
        }
    }

    .btn-outline-delete {
        color: #dc3545 !important;
        border: 1px solid #dc3545 !important;

        &:hover {
            background: #ffabb3 !important;
            color: #dc3545 !important;
            //border: 1px solid #dc354500 !important;
        }
    }
}
::v-deep {
    .v-input--selection-controls {
        padding-top: 0 !important;
    }

    .v-input--selection-controls__ripple {
        display: none;
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
    }

    .v-input--selection-controls.v-input .v-label {
        font-family: "open sans" !important;
        font-size: 14px !important;
        color: #2c3e50 !important;
    }
}
</style>
